import React from 'react'
import { Box } from '@chakra-ui/react'
import { Tooltip } from '@chakra-ui/react'
import { Tag, TagLabel } from '@chakra-ui/react'

import { formatClinicName, stringToColor } from '~utils/helpers'
import { ClinicFieldsFragment } from '~graphql/generated/graphql'

export default function ClinicTag({
    clinic,
}: {
    clinic: Pick<ClinicFieldsFragment, 'id' | 'name'>
}) {
    return (
        <Tooltip
            label={clinic.name}
            hasArrow
            bg="white"
            borderColor="blackAlpha.200"
            borderWidth={1}
            fontSize="12px"
            color="gray.700"
            rounded="lg"
        >
            <Tag size="sm" colorScheme={stringToColor(clinic.name)}>
                <TagLabel
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    maxW="160px"
                >
                    {formatClinicName(clinic.name)}
                </TagLabel>
            </Tag>
        </Tooltip>
    )
}
